module.exports = __webpack_public_path__ + "static/media/view_po_3.d19b069a.png";